import Form from 'react-bootstrap/Form';
import * as React from 'react';

export const Select = ({value, onChange, children}) => (
  <Form.Control
    as={'select'}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  >
    {children}
  </Form.Control>
);
